'use client';

import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Button, Typography } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';

import '@/components/productLibrary/productLibrary.scss';

export function RestrictLocation() {
  const { t } = useTranslation('unauthorized');
  const router = useRouter();

  return (
    <Box sx={{ position: 'relative' }}>
      <Box className="provider-detail-header">
        <Box className="p-btn-wrapper">
          <Box className="back-btn">
            <Button
              name="back-button"
              color="secondary"
              onClick={() => router.push('/product-library')}
              startIcon={<KeyboardArrowLeftOutlinedIcon />}
            >
              <span className="btn-text">{t('back', 'Back')}</span>
            </Button>
          </Box>
        </Box>
      </Box>

      <Box className="restrictedLocation">
        <LockOutlinedIcon sx={{ fontSize: 48 }} />
        <Typography variant="h6">
          {t('restrictedLocation', 'This product is not available in your region.')}
        </Typography>
        <Typography variant="body2">
          {t('restrictedLocationDesc', 'Please contact')}{' '}
          <Link href="mailto:support@skywatch.com" style={{ color: 'inherit' }}>
            {t('support', 'support')}
          </Link>{' '}
          {t('restrictedLocationDescSuffix', 'for more information.')}
        </Typography>
      </Box>
    </Box>
  );
}
